'use client';
import React from 'react';
import SVGIcons from '@components/SVGIcon';
import ArtContainer from '../ArtContainer';
import { logEvent } from '@utils/googleAnalytics';
import cn from './style.module.scss';

type Props = {
  t: Record<string, string>;
  bannerSrc: string;
};
export default function ArtService(props: Props) {
  const { t } = props;
  const handleRegisterForCallClick = () =>
    logEvent({
      event: 'launch-register-interest-click',
      additionalInfo: {
        link_id: 'launch-register-interest-click',
        section: 'navigation',
      },
    });

  return (
    <section
      className={cn.artService}
      style={{
        backgroundImage: `url(${props.bannerSrc})`,
      }}
    >
      <div className={cn.serviceData}>
        <ArtContainer>
          <div className={cn.serviceBody}>
            <div className={cn.serviceSection}>
              <div className={cn.serviceHeader}>
                <h2>{t['serviceHeading']}</h2>
                <p>{t['serviceContent']}</p>
                <div className={cn.getCall}>
                  <a
                    id="launch-register-interest-click"
                    className={cn.getButton}
                    onClick={handleRegisterForCallClick}
                    href="#teaserContact"
                  >
                    {' '}
                    {t['actionButton']}{' '}
                  </a>
                </div>
              </div>
              <div className={cn.serviceDetails}>
                <ul className={cn.detailsElements}>
                  <li>
                    <div className={cn.detailsIcon}>
                      <span>
                        <SVGIcons type="art-service-one-svg" />
                      </span>
                    </div>
                    <h4>{t['serviceTabOne']}</h4>
                  </li>
                  <li>
                    <div className={cn.detailsIcon}>
                      <span>
                        <SVGIcons type="art-service-two-svg" />
                      </span>
                    </div>
                    <h4>{t['serviceTabTwo']}</h4>
                  </li>
                  <li>
                    <div className={cn.detailsIcon}>
                      <span>
                        <SVGIcons type="art-service-three-svg" />
                      </span>
                    </div>
                    <h4>{t['serviceTabThree']}</h4>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </ArtContainer>
      </div>
    </section>
  );
}
